"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=goods-receipt-note.dto.js.map